export const PRODUCTS = [
    {
        slug: "paper-salad-bowls",
        title: "Paper Salad Bowls",
        chapter: "01",
        tagline: "Cold, crunchy, and completely food-safe.",
        summary: "Rigid paper salad bowls engineered for greens, grains and generous toppings — available in brown kraft, plain white and custom brand-printed finishes, PE-coated or Aqueous-coated, fully food-safe.",
        highlights: [
            { label: "Sizes", value: "500 · 750 · 1000 ML" },
            { label: "Finishes", value: "Brown kraft · Plain white · Brand printing" },
            { label: "Coating", value: "PE · Aqueous" },
            { label: "MOQ", value: "10,000 units" },
        ],
        image: "https://customer-assets-v7afamib.emergentagent.net/job_eco-pack-portal-1/artifacts/jfii9597_AdobeStock_579011444.webp",
        specs: [
            { size: "500 ML", top: 148, height: 48, bottom: 128, lid: "Yes", gsm: "300-350", image: "/generated/kraft_bowl_50.png" },
            { size: "750 ML", top: 148, height: 63, bottom: 128, lid: "Yes", gsm: "300-350", image: "/generated/kraft_bowl_65.png" },
            { size: "1000 ML", top: 148, height: 74, bottom: 128, lid: "Yes", gsm: "300-350", image: "/generated/kraft_bowl_80.png" },
        ],
        faqs: [
            {
                q: "What sizes are your paper salad bowls available in?",
                a: "Three sizes: 500 ML, 750 ML and 1000 ML. All share a 148 mm top diameter and 128 mm base, with heights of 48, 63 and 74 mm respectively — so one lid fits the entire range.",
            },
            {
                q: "Which lid fits your salad bowls?",
                a: "Our 148 mm PET flat lids snap onto every salad bowl size with a secure seal. The flat profile keeps stacks stable during delivery and shows contents clearly for grab-and-go displays.",
            },
            {
                q: "Are the bowls suitable for oily or dressed salads?",
                a: "Yes. Choose PE coating for oily dressings and longer hold times, or Aqueous (water-based, plastic-film-free) coating for cold, short-transit applications. Both are food-safe on 300–350 GSM rigid board.",
            },
            {
                q: "What is the minimum order quantity?",
                a: "10,000 units per SKU for plain kraft or white bowls, and 20,000 units per SKU for custom brand-printed runs. Sample kits are available without a minimum order.",
            },
            {
                q: "Can I print my brand on the salad bowls?",
                a: "Yes. We offer full custom printing from vector artwork (.ai/.pdf) in CMYK. Typical turnaround is 10–14 working days from plate approval.",
            },
        ],
    },
    {
        slug: "paper-soup-bowls",
        title: "Paper Soup Bowls",
        chapter: "02",
        tagline: "Hot liquids, held perfectly.",
        summary: "Rigid paper soup bowls with lid compatibility — for broths, curries, ramen and stews. Available in brown kraft, plain white and custom brand-printed finishes, PE-coated or Aqueous-coated, fully food-safe.",
        highlights: [
            { label: "Sizes", value: "250 · 350 · 500 · 750 ML" },
            { label: "Finishes", value: "Brown kraft · Plain white · Brand printing" },
            { label: "Coating", value: "PE · Aqueous" },
            { label: "MOQ", value: "10,000 units" },
        ],
        image: "https://customer-assets-v7afamib.emergentagent.net/job_eco-pack-portal-1/artifacts/gl8cwemn_AdobeStock_1520402546.webp",
        specs: [
            { size: "250 ML", top: 110, height: 50, bottom: 92, lid: "Yes", gsm: "300-350", image: "/generated/kraft_bowl_50.png" },
            { size: "350 ML", top: 110, height: 65, bottom: 90, lid: "Yes", gsm: "300-350", image: "/generated/kraft_bowl_65.png" },
            { size: "500 ML", top: 110, height: 80, bottom: 92, lid: "Yes", gsm: "300-350", image: "/generated/kraft_bowl_80.png" },
            { size: "750 ML", top: 110, height: 110, bottom: 85, lid: "Yes", gsm: "300-350", image: "https://customer-assets-v7afamib.emergentagent.net/job_eco-pack-portal-1/artifacts/4hvsl06m_AdobeStock_491552839.webp" },
        ],
        faqs: [
            {
                q: "What sizes do your paper soup bowls come in?",
                a: "Four sizes: 250, 350, 500 and 750 ML — all with a 110 mm top diameter, so a single lid range covers broths, curries, ramen and stews.",
            },
            {
                q: "Can your soup bowls handle hot liquids?",
                a: "Yes. The 300–350 GSM rigid board with PE or Aqueous coating is engineered for hot liquids — broths, dals and curries — without softening or leaking during normal service.",
            },
            {
                q: "PE or Aqueous coating for soup — which should I choose?",
                a: "For hot, oily or long-hold soups we recommend PE coating. Aqueous coating suits shorter transit times and buyers prioritising a plastic-film-free specification.",
            },
            {
                q: "What is the MOQ for soup bowls?",
                a: "10,000 units per SKU for plain bowls and 20,000 units per SKU for custom-printed runs. Sample kits ship without a minimum order so you can test them on your menu first.",
            },
            {
                q: "Do the soup bowls take the same lids as the salad bowls?",
                a: "No. Soup bowls use a 110 mm top diameter and salad bowls 148 mm, so each range has its own matching lid. Tell us your menu mix and we will spec the right pairing.",
            },
        ],
    },
    {
        slug: "pet-flat-lids",
        title: "PET Flat Lids",
        chapter: "03",
        tagline: "Clarity where paper needs a window.",
        summary: "Crystal-clear, recyclable FLAT PET lids designed to pair with every bowl we make. Universal fit with a secure snap-on seal — flat profile means efficient stacking and shipping.",
        highlights: [
            { label: "Format", value: "Flat lid (single profile)" },
            { label: "Material", value: "Recyclable rPET" },
            { label: "Fit", value: "148 mm top · Universal" },
            { label: "MOQ", value: "20,000 units" },
        ],
        image: "/generated/pet_lid_v2.png",
        specs: [
            { size: "Standard", top: 148, height: 8, bottom: 148, lid: "Flat", gsm: "300 microns" },
        ],
        faqs: [
            {
                q: "Which bowls do your PET flat lids fit?",
                a: "They are designed for our 148 mm paper salad bowl range (500, 750 and 1000 ML) with a universal snap-on fit and a secure seal for delivery.",
            },
            {
                q: "Are the lids recyclable?",
                a: "Yes. They are made from recyclable rPET at 300 microns, in a single flat profile that stacks efficiently for storage and shipping.",
            },
            {
                q: "Why flat lids instead of dome lids?",
                a: "A flat profile stacks more securely in delivery bags, uses less material, and gives a clean surface for labels, tamper-evident seals and branding stickers.",
            },
            {
                q: "What is the MOQ for PET flat lids?",
                a: "20,000 units per SKU. Sample kits are available without a minimum so you can test the fit and seal on your menu items first.",
            },
        ],
    },
];

export const INDUSTRIES = [
    { chapter: "01", title: "Quick-Service Restaurants", body: "High-volume, brand-critical unboxing. We ship to QSR chains across India and export markets.", image: "/generated/industry_qsr.png" },
    { chapter: "02", title: "Cloud Kitchens", body: "Fast turnaround, small MOQs, print-forward. Our production lines are built for the 2-week reorder cycle.", image: "/generated/industry_cloud_kitchen.png" },
    { chapter: "03", title: "Cafés & Bakeries", body: "Bowls, cups and clamshells for grab-and-go — with the tactile feel that premium café brands demand.", image: "/generated/industry_cafe.png" },
    { chapter: "04", title: "Airline Catering", body: "Certified, sealed formats for in-flight catering programs.", image: "/generated/industry_airline.png" },
    { chapter: "05", title: "Grocery & Meal Kits", body: "Retail-ready packaging with barcode surfaces, tamper-evident lids, and cold-chain integrity.", image: "/generated/industry_grocery.png" },
];

export const BUSINESS_TYPES = ["Distributor", "Restaurant", "QSR", "Wholesaler", "Exporter", "Cloud Kitchen", "Retail Chain", "Other"];
export const PRODUCT_OPTIONS = ["Paper Salad Bowls", "Paper Soup Bowls", "PET Flat Lids", "Custom Printing", "Other"];

// Public contact video (user-uploaded)
export const CONTACT_VIDEO_URL = "https://customer-assets-v7afamib.emergentagent.net/job_eco-pack-portal-1/artifacts/y8hzwfx2_AdobeStock_248321608.mov";
